import { QRFC } from "./QRFC";
import { Globals } from "./Globals";

export class QProcessPSSSO extends QRFC {
  constructor() {
    super();
    this.fPSToken = null;
  }

  InitPSSSORFC(callbackObj) {
    this.InitRemoteCall(callbackObj, "POST", true, false);
    this.SetAllowStacked(true);
  }

  GetCallName() {
    return "sso/qpayspacetoken";
  }

  SetParams(psToken) {
    this.AddEncodedParameter("pstoken", psToken);
  }

  DoTransactionComplete(response, callBackObj) {
    var s = JSON.parse(response);
    var success = s["success"];
    if (!success) {
      Globals._accountInfo.ssoFail = "PS";
    } else {
      Globals._accountInfo.SetSSOToken(s["message"]);
      Globals._accountInfo.SetPSToken(null);
    }
    callBackObj.HandleAutoLogin();
  }
}
